import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import { getCountryYearGroupRequest } from '../assign-courses/actions';
import { showToast } from '../../components/toast/actions';
import classEnum from '../../containers/class-roll/constants';

export function* renameClassroomGroup({ classroomId, groupId, newGroupName }) {
    const response = yield call(api.updateClassroomGroup, newGroupName, classroomId, groupId);
    if (response.status === 200) {
        yield put(actions.renameClassroomGroupSuccess());
    } else if (response.status === 400 || response.status === 409) {
        yield put(actions.renameClassroomGroupFailure(response.message));
        yield put(showToast(response.message, 'error'));
    } else {
        yield put(actions.renameClassroomGroupFailure());
        yield put(showToast(response.message, 'error'));
    }
}

export function* renameClassroomGroupSaga() {
    yield takeLatest(actions.RENAME_GROUP_REQUEST, renameClassroomGroup);
}

export function* getClassByClassroomId({ classroomId }) {
    const payload = yield call(api.getClassroomById, classroomId);
    if (payload.status === 200) {
        yield put(actions.getClassSuccess(payload));
    } else {
        yield put(actions.getClassFailure());
    }
}

export function* getClassByClassroomIdSaga() {
    yield takeLatest(actions.GET_CLASS_REQUEST, getClassByClassroomId);
}

export function* downloadStudentSignInCards({ productId, classroomId, SignInCardPageSizeType }) {
    const response = yield call(api.downloadClassroomStudentsSignInCards, { productId, classroomId, SignInCardPageSizeType });
    if (response.status === 201) {
        const downloadUrl = `${response.verb.url}/${response.data}`;
        yield put(actions.downloadStudentSignInCardsSuccess(downloadUrl));
    } else {
        yield put(actions.downloadStudentSignInCardsFailure());
    }
}

export function* downloadStudentSignInCardsSaga() {
    yield takeLatest(actions.DOWNLOAD_STUDENT_SIGN_IN_CARDS_REQUEST, downloadStudentSignInCards);
}

export function* saveModifiedClass({ classroomId, newClassroomName, newYearGroup }) {
    const response = yield call(api.updateClass, { classroomId, newClassroomName, newYearGroup });
    if (response.status === 200) {
        yield put(actions.saveModifiedClassSuccess());
    } else if (response.status === 400 || response.status === 409) {
        yield put(actions.saveModifiedClassFailure(response.message));
        yield put(showToast(response.message, 'error'));
    } else {
        yield put(actions.saveModifiedClassFailure(''));
        yield put(showToast(response.message, 'error'));
    }
}

export function* saveModifiedClassSaga() {
    yield takeLatest(actions.MODIFIED_CLASS_SAVE_REQUEST, saveModifiedClass);
}

export function* downloadTeacherSignInCards({ teacherId, productId, downloadingTeachersIds, format }) {
    const teacherSignInCardsData = { teacherUserProfileIds: [teacherId], SignInCardPageSizeType: format };
    const response = yield call(api.downloadTeachersSignInCards, productId, teacherSignInCardsData);
    if (response.status === 201) {
        const downloadUrl = `${response.verb.url}/${response.data}`;
        yield put(actions.printClassroomTeacherSignInCardSuccess(teacherId, downloadUrl, downloadingTeachersIds));
    } else {
        yield put(actions.printClassroomTeacherSignInCardFailure(teacherId, downloadingTeachersIds));
    }
}

export function* downloadTeachersSignInCardSaga() {
    yield takeEvery(actions.PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_REQUEST, downloadTeacherSignInCards);
}

export function* unassignTeacher({ classroomId, selectedTeachers, productId }) {
    const userRelationship = { productId, classroomId, teachersProfileIdToUnassign: selectedTeachers };
    const response = yield call(api.unAssignTeachers, userRelationship);
    if (response.status === 200) {
        yield put(actions.unassignTeachersSuccess());
    } else {
        yield put(actions.unassignTeachersFailure());
    }
}

export function* unassignTeacherSaga() {
    yield takeLatest(actions.UNASSIGN_TEACHER_REQUEST, unassignTeacher);
}

export function* deleteClassroomGroup({ classroomId, groupId }) {
    const response = yield call(api.deleteClassroomGroup, classroomId, groupId);
    if (response.status === 200) {
        yield put(actions.deleteGroupSuccess());
    } else {
        yield put(actions.deleteGroupFailure());
    }
}

export function* deleteClassroomGroupSaga() {
    yield takeLatest(actions.DELETE_GROUP_REQUEST, deleteClassroomGroup);
}

export function* changeClassroomCourse({ classroomId, groupId, courseId, submittedFields, upfCourseId, newCourseId, useUpfSchoolDefault }) {
    const response = yield call(api.changeClassroomCourse, classroomId, groupId, courseId, upfCourseId, newCourseId, useUpfSchoolDefault);
    if (response.status === 200) {
        yield put(actions.changeCourseSuccess(classroomId, groupId, courseId, submittedFields, upfCourseId, newCourseId, useUpfSchoolDefault, response));
    } else {
        yield put(actions.changeCourseFailure());
    }
}

export function* changeClassroomCourseSaga() {
    yield takeLatest(actions.CHANGE_COURSE_REQUEST, changeClassroomCourse);
}

export function* addGroup({ classroomId, name }) {
    const response = yield call(api.addGroup, classroomId, name);
    if (response.status === 200) {
        yield put(actions.addGroupSuccess(response));
    } else {
        const hasExceededGroup = response.code !== 'MaxGroupInClassExceeded';
        yield put(actions.addGroupFailure(response));

        if (hasExceededGroup) {
            yield put(showToast(response.message, 'error'));
        }
    }
}

export function* addGroupSaga() {
    yield takeLatest(actions.ADD_GROUP_REQUEST, addGroup);
}

export function* changeCourseCarryOver({ classroomId, groupId, newCourseId, newUpfCourseId, taskActionType, courses, newConquestCourseId }) {
    const response = yield call(api.changeCourseCarryOver, classroomId, groupId, newCourseId, newUpfCourseId, taskActionType, courses, newConquestCourseId);
    if (response.status === 200) {
        yield put(actions.changeCourseCarryOverSuccess());
    } else {
        yield put(actions.changeCourseCarryOverFailure());
        yield put(showToast(response.message, 'error'));
    }
}

export function* changeCourseCarryOverSaga() {
    yield takeLatest(actions.CHANGE_COURSE_CARRY_OVER_REQUEST, changeCourseCarryOver);
}


export function* handleCountryDropdownChanges({ value }) {
    const countryCode = (value !== classEnum.SCHOOL_COURSES) ? value : '';
    yield put(getCountryYearGroupRequest(countryCode, actions.getYearGroupsByCountrySuccess, actions.getYearGroupsByCountryFailure));
}

export function* handleCountryDropdownChangesSaga() {
    yield takeLatest(actions.HANDLE_COUNTRY_DROPDOWN_CHANGES, handleCountryDropdownChanges);
}



// WEBPACK FOOTER //
// ./app/containers/edit-class/saga.js